<p-multiSelect
  styleClass="pp-ms"
  [options]="options"
  [optionLabel]="optionLabel"
  [optionValue]="optionValue"
  [placeholder]="placeholder"
  [filter]="filter"
  [display]="display"
  [disabled]="disabled"
  [ngModel]="value"
  (ngModelChange)="onValueChange($event)"
  (onBlur)="onBlur()"
  appendTo="body">
</p-multiSelect>
